window.app_models.state = {
    "id":null,
    "abbr":null,
    "name":null
};


// WEBPACK FOOTER //
// ./resources/assets/js/models/state.js